// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__6Vjlu","colCheckbox":"styles_colCheckbox__2-9Y_"};